<script>
import PropertyLayout from '@layouts/property'
import MemberLayout from '@layouts/member'
import BgScreenLayout from '@layouts/bg-screen'

export default {
  components: { PropertyLayout, MemberLayout, BgScreenLayout },

  props: {
    layout: { type: String, default: 'property' },
    layoutComponents: { type: Array, default: () => [] },
    property: { type: Object, required: true },
  },

  computed: {
    currentLayout() {
      switch (this.layout) {
        case 'bg-screen':
          return BgScreenLayout
        case 'member':
          return MemberLayout
        default:
          return PropertyLayout
      }
    },
  },
}
</script>

<template>
  <component :is="currentLayout" v-bind="$props"></component>
</template>
